import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1";
const FALLBACK_MESSAGE = "\u062e\u0637\u0627 \u062f\u0631 \u0627\u0631\u062a\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631";
const DELETE_FAILED_MESSAGE = "\u062d\u0630\u0641 \u0622\u06cc\u062a\u0645 \u0646\u0627\u0645\u0648\u0641\u0642 \u0628\u0648\u062f";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

async function postForm(path, payload = {}, fallbackMessage = FALLBACK_MESSAGE) {
  const form = new FormData();
  Object.entries(payload).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") form.append(k, v);
  });
  return requestWithAuth(
    `${API_BASE}${path}`,
    {
      method: "POST",
      body: form,
    },
    { fallbackMessage }
  );
}

export function createCartItem(payload) {
  return postForm("/cart/create/", payload);
}

export function getCartItems() {
  return request("/cart/items/");
}

export async function deleteCartItem(id) {
  try {
    await request(`/cart/item/delete/${id}/`, { method: "DELETE" });
    return;
  } catch (err) {
    if (err?.isAuthError) throw err;
  }
  const form = new FormData();
  form.append("id", id);
  await requestWithAuth(
    `${API_BASE}/cart/items/delete/`,
    {
      method: "POST",
      body: form,
    },
    { fallbackMessage: DELETE_FAILED_MESSAGE }
  );
}

export function checkDiscount(code) {
  return postForm("/discounts/check/", { code });
}

export function checkReferral(code) {
  return postForm("/referrals/check/", { referral_code: code });
}

export function initiatePayment(payload) {
  return request("/cart/payment/initiate/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function getPaymentStatus(payment_id) {
  const params = new URLSearchParams();
  params.append("payment_id", payment_id);
  return request(`/cart/PaymentStatus/?${params.toString()}`);
}

export function getCryptoNetworks() {
  return request("/cart/payment/crypto/networks/");
}

export function cancelCryptoPayment(paymentId) {
  return request(`/cart/payment/crypto/${paymentId}/cancel/`, {
    method: "POST",
  });
}

export function submitCryptoTransactionHash(paymentId, transactionHash) {
  return request(`/cart/payment/crypto/${paymentId}/submit-hash/`, {
    method: "POST",
    body: JSON.stringify({ transaction_hash: transactionHash }),
  });
}
